<template>
  <div class="questionnaireBox">
    <div class="questionnaireCont">
      <div class="questionnaireTop">
        <img src="../assets/imgs/logo.png" alt="" />
      </div>
      <p class="questionnaireTitle">《商事调解实务与调解技能高级培训班》 报名表</p>
      <div class="divContent">
        <div class="questionnairetip">
            <!-- <p class="lawPrice">持律师证报名，可享八折优惠</p> -->
          <span class="questionnairetipText">
            此表仅用于《商事调解实务与调解技能高级培训班》 报名，且不会将您的隐私透露给任何人，请您放心填写
          </span>

          <el-form
            ref="form"
            :model="form"
            label-width="80px"
            label-position="top"
            :rules="rules"
          >
            <el-form-item label="1.您的姓名：" prop="name">
              <el-input
                v-model="form.name"
                class="bigInput"
                placeholder="请输入您的姓名"
              ></el-input>
            </el-form-item>

            <el-form-item label="2.请输入您的手机号" prop="phone">
              <el-input
                v-model="form.phone"
                class="bigInput"
                placeholder="请输入您的手机号"
              ></el-input>
            </el-form-item>

          </el-form>
        </div>
        <div class="submitBtn">
          <el-button type="primary" style="width: 150px" @click="submit"
            >提 交</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import selectAreaVue from "../components/selectArea.vue";
import { addEnterForm } from "@/assets/js/caseRequest.js";
export default {
  components: {
    selectAreaVue,
  },
  data() {
    return {
      title: "百度推广",
      form: {
        name: "",
        idNum: "",
        phone: "",
        edu: "",
        province: "",
        city: "",
        email: "",
        unit: "",
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],

        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[34578]\d{9}$/, //正则校验不用字符串
            message: "请填写正确的手机号码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    areaInfo(e) {
      this.form.province = e.province;
      this.form.city = e.city;
    },
    submit() {
      // this.$router.push({
      //   path: "/result",
      // });
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          let datas = {
            officialName: this.form.name,
            mobilePhone: this.form.phone,
            idNo: new Date().getTime(),
            eduDegree: this.form.edu,
            province: this.form.province,
            city: this.form.city,
            userEmail: this.form.email,
            workUnit: this.form.unit,
            formTitle: this.title,
          };
          let res = await addEnterForm(datas);
          if (res.code == 200) {
            this.$message.success("提交信息成功");
            // return
            this.$router.push({
              path: "result",
            });
          } else {
            this.$message.error(res.msg);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.questionnaireBox {
  width: 100vw;
  min-height: 100vh;
  background: linear-gradient(90deg, #daf0fd, #e4e8ff);
}
>>> .el-radio {
  display: block;
  margin-bottom: 15px;
  font-size: 15px;
}
>>> .el-form--label-top .el-form-item__label {
  font-size: 15px;
  font-weight: 600;
}
>>> .el-select__caret.el-input__icon.el-icon-:before {
  content: "\e6e1";
}
.lawPrice {
  text-align: center;
  color: red;
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 20px;
}
@media screen and (min-width: 800px) {
  .questionnaireBox {
    padding-bottom: 50px;
    padding-top: 100px;
  }
  .questionnaireTop {
    width: 100%;
    height: 100px;
    background: #bee4ff;
    display: flex;
    align-items: center;
    img {
      height: 80px;
      margin-left: 30px;
      margin: 0 auto;
    }
  }
  .questionnaireCont {
    width: 800px;
    background: #fff;
    margin: 0 auto;
    padding-bottom: 100px;
  }
  .questionnaireTitle {
    color: #0095ff;
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    margin-top: 40px;
    margin-bottom: 20px;
  }
  .divContent {
    padding: 0 30px;
  }
  .questionnairetip {
    padding: 0 25px;
  }
  .questionnairetipText {
    border-bottom: 1px dashed #999;
    padding-bottom: 20px;
    font-size: 15px;
    display: block;
    margin-bottom: 30px;
  }
  .bigInput {
    width: 400px;
  }
  .submitBtn {
    display: flex;
    justify-content: center;
    margin-top: 50px;
  }
}
@media screen and (max-width: 800px) {
  .questionnaireBox {
    padding-bottom: 0;
  }
  .questionnaireCont {
    width: 100vw;
    background: #fff;
    margin: 0 auto;
  }
  .questionnaireTop {
    width: 100%;
    height: 80px;
    background: #bee4ff;
    display: flex;
    align-items: center;
    img {
      height: 60px;
      margin: 0 auto;
    }
  }
  .questionnaireTitle {
    color: #0095ff;
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    // margin-top: 40px;
    padding: 0 40px;
    padding-top: 20px;
    margin-bottom: 20px;
  }
  .divContent {
    padding: 0 10px;
  }
  .questionnairetip {
    padding: 0 10px;
  }
  .questionnairetipText {
    border-bottom: 1px dashed #999;
    padding-bottom: 20px;
    font-size: 15px;
    display: block;
    margin-bottom: 30px;
  }
  .bigInput {
    // width: 300px;
  }
  .submitBtn {
    display: flex;
    justify-content: center;
    margin-top: 50px;
    padding-bottom: 50px;
  }
}
</style>>



// WEBPACK FOOTER //
// src/views/index.vue